import { render, staticRenderFns } from "./FieldType20.vue?vue&type=template&id=1ab2bfee&scoped=true"
import script from "./FieldType20.vue?vue&type=script&lang=js"
export * from "./FieldType20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2bfee",
  null
  
)

export default component.exports